import { create } from 'zustand';

interface ErrorsState {
  isOn404: boolean;
  setIsOn404: (value: boolean) => void;
}

export const useErrorsStore = create<ErrorsState>((set) => ({
  isOn404: false,
  setIsOn404: (value) => set({ isOn404: value }),
}));
